import { createAction, props } from '@ngrx/store';

export const getPropertiesData = createAction('[Properties Pane] Get Data', props<{ propPaneApiConstants: any }>());

export const setPropertiesData = createAction('[Properties Pane] Set Data', props<{ propertiesData: any }>());

export const setAllPropertiesData = createAction('[Properties Pane] Set All Data', props<{ allProperties: any }>());

export const getPropertiesValues = createAction(
  '[Properties Pane] Get Values',
  props<{ propPaneApiConstants: any; params: any }>()
);

export const setPropertiesValues = createAction(
  '[Properties Pane] Set Values',
  props<{ propertiesValues: any; currentScreenId?: any }>()
);
export const clearLookUp = createAction('[Properties Pane] Clear Lookup', props<{ clear: any }>());
export const setScreenValues = createAction('[Properties Pane] Set Values', props<{ screenValues: any }>());

export const getPropertiesType = createAction('[Properties Pane] Get Type', props<{ propertiesType: any }>());

export const setPropertiesType = createAction('[Properties Pane] Set Type', props<{ propertiesType: any }>());

export const savePropertiesValues = createAction(
  '[Properties Pane] save Values',
  props<{ apiConstants: any; propertiesValues: any }>()
);

export const updatePropertiesValues = createAction(
  '[Properties Pane] update Values',
  props<{ apiConstants: any; propertiesValues: any }>()
);

export const deletePropertiesValues = createAction(
  '[Properties Pane] delete Values',
  props<{ apiConstants: any; propertyId: any }>()
);

export const setPickupProperties = createAction('[Properties Pane] Set Pickup Properties', props<{ picklist: any }>());

export const getPickupProperties = createAction('[Properties Pane] Get Pickup Properties', props<{ picklist: any }>());

export const setLookupFields = createAction('[Properties Pane] Set Lookup Fields', props<{ lookupFields: any }>());

export const setMandatryFil = createAction(
  '[Properties Pane] Set Mandatory Fields',
  props<{ mandatoryFilters: any }>()
);

export const setParentNodeType = createAction('[Properties Pane] Set Parent Node', props<{ parentNodeType: any }>());

export const settableFields = createAction('[Properties Pane] Set Table Fields', props<{ tabMapFlds: any }>());

export const setMFTblFields = createAction('[Properties Pane] Set current Table Fields', props<{ mfTblFlds: any }>());

export const setLkfuncPKFields = createAction(
  '[Properties Pane] Set Lookup Primary key Fields',
  props<{ funcPKflds: any }>()
);

export const setSelectedLKTbl = createAction('[Properties Pane] Set Selected lookup table', props<{ selLkTbl: any }>());

export const triggerLoading = createAction(
  '[Properties Pane] Trigger Loading',
  props<{ triggerPropLoading: boolean }>()
);

export const setTableNames = createAction('[Properties Pane] Set table names', props<{ tableNames: any }>());

export const setCurrentNodeData = createAction(
  '[Properties Pane] Set Current Node data',
  props<{ curNodeData: any }>()
);

export const getSearchableFields = createAction(
  '[Properties Pane] Get Searchable Fields',
  props<{ apiConstants: any; params: any }>()
);

export const setSearchableFields = createAction(
  '[Properties Pane] Set Searchable Fields',
  props<{ searchFields: any }>()
);
